import { render, staticRenderFns } from "./PracticeOrderWrong.vue?vue&type=template&id=6cc9879b&scoped=true"
import script from "./PracticeOrderWrong.vue?vue&type=script&lang=js"
export * from "./PracticeOrderWrong.vue?vue&type=script&lang=js"
import style0 from "./PracticeOrderWrong.vue?vue&type=style&index=0&id=6cc9879b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc9879b",
  null
  
)

export default component.exports